import "./textarea.css";
import Component from "react-pure-render/component";
import Textarea from "react-textarea-autosize";
import React, { PropTypes } from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";

export default class TextArea extends Component {
  static propTypes = {
    field: PropTypes.array,
    actions: PropTypes.object
  };

  static defaultProps = {
    type: "text"
  };

  constructor(props) {
    super(props);

    this.timeoutTime = 300;
    this.timeout = null;
  }

  onChange = ({ target: { value } }) => {
    const { actions, feature, uid, field } = this.props;
    actions.setEntityField(feature, uid, field, value);
  };

  render() {
    const {
      uid,
      field,
      actions,
      entity,
      placeholder,
      disabled,
      type,
      onClick,
      feature,
      className
    } = this.props;

    return (
      <Textarea
        id={uid}
        name={uid}
        className={className}
        onChange={this.onChange}
        placeholder={placeholder ? placeholder : null}
        onClick={onClick}
        value={entity !== undefined ? entity.getIn([].concat(field)) : ""}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/textarea.react.js